var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifierPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFE4E8",
    d: "M38.529 35.947c3.069-3.912 4.737-8.74 4.737-13.713.076-5.785-2.155-11.362-6.199-15.5C33.023 2.598 27.498.24 21.713.185 15.934.253 10.42 2.614 6.382 6.75 2.344 10.885.115 16.455.184 22.234c-.07 5.78 2.16 11.35 6.198 15.484 4.037 4.136 9.552 6.498 15.331 6.566 5.472-.013 10.725-2.143 14.66-5.945l2.156-2.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.3 13.661L20.126 13.661 20.126 20.6 13.329 20.6 13.329 23.868 20.126 23.868 20.126 30.808 23.3 30.808 23.3 23.868 30.074 23.868 30.074 20.6 23.3 20.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierPlus);
export default __webpack_public_path__ + "static/media/magnifier-plus.f3ca5b486047ab5eb338a449a68b70fb.svg";
export { ForwardRef as ReactComponent };